
import useSWR from "swr";
import { useMemo } from "react";

// axios
import { fetcher, endpoints, postFetcher } from "../utils/axios";

export function useGetClo() {
    const { data, isLoading, error, isValidating } = useSWR(endpoints.clo.active, fetcher, {
        keepPreviousData: true,
        revalidateOnFocus: false,  
        revalidateOnReconnect: false 
    });

    const memoizedValue = useMemo(() => {
        if (data && !isLoading && !isValidating) {
            return {
                clo: data.clo,
                cloLoading: false,
                cloError: error,
                cloValidating: false
            };
        }
        return {
            clo: data?.clo,
            cloLoading: isLoading,
            cloError: error,
            cloValidating: isValidating
        };
    }, [data, isLoading, error, isValidating]); // Incluye 'data' completo como dependencia

    return memoizedValue;
}

export function useGetNurByClo(clo){

    const URL = clo ? endpoints.clo.nur : null;


    const { data, isLoading, error, isValidating, mutate } = useSWR(URL, () => postFetcher(URL,{ arg: { clo } }));

    const memoizedValue = useMemo(
        () => ({
            nur: data?.nur,
            nurLoading: isLoading,
            nurError: error,
            nurValidating: isValidating,
            nurMutate: mutate,
        }), [ data?.nur, isLoading, error, isValidating, mutate ]
    )

    return memoizedValue;
}

export function useGetRutaByClo(clo){

    const URL = clo ? endpoints.clo.ruta : null;


    const { data, isLoading, error, isValidating, mutate } = useSWR(URL, () => postFetcher(URL,{ arg: { clo } }));

    const memoizedValue = useMemo(
        () => ({
            ruta: data?.ruta,
            rutaLoading: isLoading,
            rutaError: error,
            rutaValidating: isValidating,
            rutaMutate: mutate,
        }), [ data?.ruta, isLoading, error, isValidating, mutate ]
    )

    return memoizedValue;
}

